// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../.nvm/versions/node/v14.21.3/lib/node_modules/@fangzhou/stark/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-8ef30 {\n  width: 100%;\n  line-height: 0;\n  font-size: 32px;\n  color: #000000;\n}\n", ""]);
// Exports
exports.locals = {
	"icon": "icon-8ef30"
};
module.exports = exports;
